
import { Component, Vue } from 'vue-property-decorator'
import { getProductList, setProductInfo } from '@/api/product/product'
import { statusList } from '@/utils/constant'
import { AppModule } from '@/store/modules/app'
import productInfo from './components/productInfo.vue'
import editProductBank from './components/editProductBank.vue'
import thaiExtraParam from './components/thaiExtraParam.vue'
import trueh5Extra from './components/trueh5Config.vue'
import indExtra from './components/indExtra.vue'
import ylpayExtra from './components/ylpayExtra.vue'
import indiaQrExtra from './components/indiaQrExtra.vue'
import indiaExtra from './components/IndiaH5Extra.vue'
import usdtExtra from './components/usdtExtra.vue'
import indusdt from './components/indusdt.vue'
import subProduct from './subProduct/index.vue'

@Component({
  name: 'productList',
  components: {
    productInfo,
    editProductBank,
    thaiExtraParam,
    ylpayExtra,
    indiaQrExtra,
    indiaExtra,
    usdtExtra,
    indExtra,
    trueh5Extra,
    indusdt,
    subProduct
  }
})
export default class extends Vue {
  private productList: any[] = []
  private dialogVisible: boolean = false
  private centerDrawerVisible: boolean = false
  private currentProduct: any | null = null
  private listLoading = true
  private statusList = statusList
  private bankList: any[] = []
  private activeName: any = 'first'

  get language() {
    return AppModule.language
  }

  private closeDialogVisible() {
    this.dialogVisible = false
    this.getList()
  }
  private closeDialog(b: boolean) {
    this.centerDrawerVisible = b
  }

  private isCanChange(code: string) {
    return !!AppModule.constant['PRODUCT_CHECKOUT_COUNTER_PARAM'][code]
  }

  private productType: any = []
  private async getList() {
    try {
      this.listLoading = false
      await getProductList({}).then((res: any) => {
        this.productList = res
        this.listLoading = false
      })
    } catch (e) {
      this.listLoading = false
    }
  }

  private async setStatus(obj: any) {
    // 保存原来的状态
    const status = obj.status === 0 ? 1 : 0
    const data: any = {
      id: obj.id,
      status: obj.status
    }
    try {
      await setProductInfo(data).then((res: any) => {
        if (this.language === 'en') {
          this.$message({
            message: 'Save successful!',
            type: 'success'
          })
        }
        if (this.language === 'zh_cn') {
          this.$message({
            message: '保存成功!',
            type: 'success'
          })
        }
        if (this.language === 'zh_tw') {
          this.$message({
            message: '保存成功!',
            type: 'success'
          })
        }
      })
    } catch (e) {
      obj.status = status
    }
  }

  private openDrawerVisible(product: any) {
    this.currentProduct = product
    console.log(this.currentProduct)

    this.dialogVisible = true
    this.activeName = 'first'
  }

  private siteName = this.$store.state.app.enterprise.ssl_switch.site_name
  private systemName: any = 'Admin System'
  private sitelogo: any = this.$store.state.app.enterprise.ssl_switch.site_logo
  private systemLogo: any = ''

  mounted() {
    this.getList()
    if (this.siteName && this.siteName !== '') {
      AppModule.SetSiteName(this.siteName)
      document.title = this.siteName + ' ' + this.$t(`route.operation`)
    } else {
      AppModule.SetSiteName(this.systemName)
      document.title = this.$t(`route.productManage`) + '- Admin System'
    }
    if (this.sitelogo && this.sitelogo !== '') {
      AppModule.SetSiteLogo(this.sitelogo)
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.sitelogo
      document.getElementsByTagName('head')[0].appendChild(link)
    } else {
      AppModule.SetSiteLogo(this.systemLogo)
      let link: any =
        document.querySelector("link[rel*='icon']") ||
        document.createElement('link')
      link.type = 'image/x-icon'
      link.rel = 'shortcut icon'
      link.href = this.systemLogo
      document.getElementsByTagName('head')[0].appendChild(link)
    }
  }
}
